import { combineReducers } from "@reduxjs/toolkit";
import mainMenuSlice from "./slices/mainMenuSlice";
import actionSlice from "./slices/actionSlice";
import menuGroupSlice from "./slices/menuGroupSlice";
import menuItemSlice from "./slices/menuItemSlice";
import pageSlice from "./slices/pageSlice";
import roleSlice from "./slices/roleSlice";
import userSlice from "./slices/userSlice";
import userTypeSlice from "./slices/userTypeSlice";
import fingerReasonSlice from "./slices/fingerReasonSlice";
import supervisorPermissionSlice from "./slices/supervisorPermissionSlice";
import userAHSlice from "./slices/userAHSlice";
import specialAccessUserSlice from "./slices/specialAccessUserSlice";
import reasonBlockedSlice from "./slices/reasonBlockedSlice";
import returnReasonSlice from "./slices/returnReasonSlice";
import dualPaymentsCompanySlice from "./slices/dualPaymentsCompanySlice";

export default combineReducers({
  action: actionSlice,
  mainMenu: mainMenuSlice,
  menuGroup: menuGroupSlice,
  menuItem: menuItemSlice,
  page: pageSlice,
  role: roleSlice,
  user: userSlice,
  userType: userTypeSlice,
  fingerReason: fingerReasonSlice,
  supervisorPermission: supervisorPermissionSlice,
  userAH: userAHSlice,
  specialAccessUser: specialAccessUserSlice,
  reasonBlocked: reasonBlockedSlice,
  returnReasons: returnReasonSlice,
  dualPaymentsCompany: dualPaymentsCompanySlice,
});
